const CATEGORY_TEXT_COLOR_MAP: Record<string, string> = {
  '#F4CCCC': '#CC0000',
  '#FCE5CD': '#B45F06',
  '#D9EAD3': '#38761D',
  '#FFF2CC': '#BF9000',
  '#D9D2E9': '#5B3F9C',
}

const FALLBACK_BACKGROUND = '#E0E0E0'
const FALLBACK_TEXT = '#555555'

const isKnownColor = (color: string | null | undefined): boolean =>
  !!color && color.toUpperCase() in CATEGORY_TEXT_COLOR_MAP

export const getCategoryBackgroundColor = (color: string | null | undefined): string => {
  if (isKnownColor(color)) return (color as string).toUpperCase()
  return FALLBACK_BACKGROUND
}

export const getCategoryTextColor = (color: string | null | undefined): string => {
  if (isKnownColor(color)) return CATEGORY_TEXT_COLOR_MAP[(color as string).toUpperCase()]
  return FALLBACK_TEXT
}
